/**
 * HELLYWEAR — PREMIUM JS
 */
(function () {
  'use strict';

  function initHeaderBlur() {
    var h = document.querySelector('.header-wrapper');
    if (!h) return;
    function onScroll() {
      if ((window.scrollY || window.pageYOffset) > 50) {
        h.classList.add('header-wrapper--scrolled');
      } else {
        h.classList.remove('header-wrapper--scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initScrollReveal() {
    var style = document.createElement('style');
    style.textContent = '.hw-reveal{opacity:0;transform:translateY(28px);transition:opacity .7s ease,transform .7s ease}.hw-reveal.hw-revealed{opacity:1;transform:translateY(0)}';
    document.head.appendChild(style);
    var els = [];
    ['.card-wrapper','.collection__title .title','.rich-text__wrapper','.image-with-text__content'].forEach(function(s){
      document.querySelectorAll(s).forEach(function(el){
        if (!el.classList.contains('scroll-trigger')) { el.classList.add('hw-reveal'); els.push(el); }
      });
    });
    document.querySelectorAll('.grid.product-grid').forEach(function(grid){
      grid.querySelectorAll('.card-wrapper.hw-reveal').forEach(function(c,i){ c.style.transitionDelay = (i*0.06)+'s'; });
    });
    if (!els.length) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('hw-revealed'); obs.unobserve(e.target); } });
    }, {threshold:0.1,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(el){ obs.observe(el); });
  }

  function init() { initHeaderBlur(); initScrollReveal(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
